export default {
  notification: {
    success: {
      copy: 'Contenido copiado con éxito.',
    },
    error: {
      copy: 'Contenido no pudo ser copiado.',
    },
  },
  label: {
    tooltip: {
      copy: 'Haga clic para copiar el contenido.',
    },
    button: 'Copiar',
  },
};
